
import React from 'react';
import { Badge } from "@/components/ui/badge";

export interface DeadlineItemProps {
  id: number;
  name: string;
  deadline: string;
  category: string;
  status: 'high' | 'medium' | 'low';
}

const DeadlineItem: React.FC<DeadlineItemProps> = ({ name, deadline, category, status }) => {
  return (
    <div className="flex items-start justify-between border-b pb-4 last:border-0 last:pb-0">
      <div>
        <h4 className="font-medium">{name}</h4>
        <div className="flex items-center gap-2 mt-1">
          <Badge variant="outline">{category}</Badge>
          <span className="text-sm text-muted-foreground">Due: {deadline}</span>
        </div>
      </div>
      <div className={`px-2 py-1 text-xs rounded-full ${
        status === 'high' 
          ? 'bg-red-100 text-red-800' 
          : status === 'medium'
            ? 'bg-yellow-100 text-yellow-800'
            : 'bg-blue-100 text-blue-800'
      }`}>
        {status} priority
      </div>
    </div>
  );
};

export default DeadlineItem;
